module.exports = __webpack_public_path__ + "img/b-next.691fc8cb.png";